import { DateRangeFilter } from '@goodfynd/dashboard';
import { styled } from '@goodfynd/theme';

export const StyledCard = styled('div', {
  border: '1px solid $Neutral05',
  borderRadius: 6,
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: 24,
  maxHeight: 352,
  maxWidth: 352,
  minHeight: 352,
  minWidth: 352,
  padding: 24,
  '@xs': {
    minWidth: '100%',
  },
});

export const StyledDateRangeFilter = styled(DateRangeFilter, {
  '&.filter': {
    borderWidth: 0,
    padding: '0 !important',
  },
});
